<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M6 27.33v-6.02q0-1 .7-1.7.72-.71 1.71-.71h15.18q1 0 1.7.7.7.71.71 1.7v6.03zm6.2-10.28q-2.58 0-4.39-1.81A6 6 0 0 1 6 10.86Q6 8.3 7.81 6.48a6 6 0 0 1 4.38-1.81h7.62q2.57 0 4.38 1.8A6 6 0 0 1 26 10.87q0 2.56-1.81 4.38a6 6 0 0 1-4.38 1.81zM8 25.33h16v-4.02a.4.4 0 0 0-.12-.3.4.4 0 0 0-.29-.11H8.41a.4.4 0 0 0-.3.11.4.4 0 0 0-.11.3zm4.2-10.28h7.6q1.77 0 2.98-1.22A4 4 0 0 0 24 10.86q0-1.75-1.22-2.98a4 4 0 0 0-2.97-1.21h-7.62q-1.75 0-2.97 1.21A4 4 0 0 0 8 10.86q0 1.76 1.22 2.97 1.21 1.22 2.97 1.22m0-3.04q.49 0 .81-.33.34-.34.34-.82 0-.5-.34-.82-.33-.33-.82-.34-.49 0-.82.34t-.33.82.33.82.82.33m7.6 0q.49 0 .83-.33.33-.34.33-.82 0-.5-.33-.82-.33-.33-.82-.34-.5 0-.82.34-.34.34-.34.82 0 .5.34.82.33.33.82.33"
      />
    </svg>
  </span>
</template>
